module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-list', {
    attrs: {
      "listItems": _vm.trainList,
      "itemComponent": _vm.trainCard
    },
    on: {
      "list-item-clicked": _vm.onTrainClicked
    }
  }, [_c('div', {
    attrs: {
      "id": "container"
    }
  }, [(_vm.noTrain) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px",
      "font-size": "28px"
    }
  }, [_vm._v("敬请期待！")]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('digTrainContentmodal', {
    attrs: {
      "game": _vm.game
    },
    on: {
      "close": function($event) {
        _vm.showModal = false
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-757086c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/train/digTrainContent.vue
// module id = 1008
// module chunks = 2